module.exports = __webpack_public_path__ + "media/04.a915dc1b.mp3";